import type { AggregateFunction } from './aggregate.js';
import { defaultAggregateForColumnType, isAggregateFunction } from './aggregate.js';
import type { ColumnConfigLike } from './select-options.js';

/** Rollup column config stored in `columns[].config`. */
export type RollupColumnConfig = {
  relationColumnId: string;
  targetPropertyId: string;
  function: AggregateFunction;
};

export function rollupRelationColumnId(config: ColumnConfigLike): string | null {
  const raw = config?.relationColumnId;
  return typeof raw === 'string' && raw.trim() ? raw.trim() : null;
}

export function rollupTargetPropertyId(config: ColumnConfigLike): string | null {
  const raw = config?.targetPropertyId;
  return typeof raw === 'string' && raw.trim() ? raw.trim() : null;
}

export function rollupAggregateFunction(
  config: ColumnConfigLike,
  targetColumnType?: string,
): AggregateFunction {
  const raw = config?.function;
  if (typeof raw === 'string' && isAggregateFunction(raw)) {
    return raw;
  }
  return defaultAggregateForColumnType(targetColumnType ?? 'text');
}

export function normalizeRollupConfigForSchema(
  config: Record<string, unknown> | undefined,
): Record<string, unknown> {
  if (!config) {
    return {};
  }
  const next: Record<string, unknown> = {};
  const relationColumnId = rollupRelationColumnId(config);
  if (relationColumnId) {
    next.relationColumnId = relationColumnId;
  }
  const targetPropertyId = rollupTargetPropertyId(config);
  if (targetPropertyId) {
    next.targetPropertyId = targetPropertyId;
  }
  const fn = config.function;
  if (typeof fn === 'string' && isAggregateFunction(fn)) {
    next.function = fn;
  }
  return next;
}
